import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-modal-confirm-dialog',
  templateUrl: './modal-confirm-dialog.component.html',
styleUrls:  ['./modal-confirm-dialog.component.css']
})
export class ModalConfirmDialogComponent implements OnInit {

	@Input() title: string = '';
	@Input() message: string = '';

	@Output() yes$: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() no$: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  handleYes() {
  	this.yes$.emit(true);
  }

  handleNo() {
  	this.no$.emit(true);
  }

}
